// @ts-nocheck

import useStreamConfig from '../../../../hooks/useStreamConfig';
import { VideoPlayerTypes } from '../../../../types/videoPlayer';
import ImmersivePlayerContainer from '../../containers/ImmersivePlayerContainer';

const HighlightVideoPlayer = ({ streamData, jwt, ...props }): Node => {
  const { url, config } = useStreamConfig({ streamData, jwt: jwt?.token, type: VideoPlayerTypes.HIGHLIGHT });

  if (!config) {
    return null;
  }

  return <ImmersivePlayerContainer fetchUrl={url} fetchConfig={config} isHighlight {...props} />;
};

export default HighlightVideoPlayer;
